import { render, staticRenderFns } from "./bjOffer.vue?vue&type=template&id=9ee190e4&scoped=true&"
import script from "./bjOffer.vue?vue&type=script&lang=js&"
export * from "./bjOffer.vue?vue&type=script&lang=js&"
import style0 from "./bjOffer.vue?vue&type=style&index=0&id=9ee190e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ee190e4",
  null
  
)

export default component.exports